var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPerson = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35705 8C10.5927 8 12.4047 6.20937 12.4047 4C12.4047 1.79063 10.5927 0 8.35705 0C6.12136 0 4.30941 1.79063 4.30941 4C4.30941 6.20937 6.12136 8 8.35705 8ZM11.3865 9.01875L9.87491 15L8.863 10.75L9.87491 9H6.83918L7.85109 10.75L6.83918 15L5.32764 9.01875C3.07298 9.125 1.27368 10.9469 1.27368 13.2V14.5C1.27368 15.3281 1.95356 16 2.79155 16H13.9226C14.7605 16 15.4404 15.3281 15.4404 14.5V13.2C15.4404 10.9469 13.6411 9.125 11.3865 9.01875Z",
    fill: "#46A72A"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPerson, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/person.44912e88.svg";
export { ForwardRef as ReactComponent };